import { render, staticRenderFns } from "./UpdateDepreciableAssets.vue?vue&type=template&id=075b7388"
import script from "./UpdateDepreciableAssets.vue?vue&type=script&lang=js"
export * from "./UpdateDepreciableAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports